function Hotline ( props ) {
    return (
        <div>
            <h1 className="header">HOTLINE</h1>
            <div className="container1">
                <div className="hotline">
                    <div className="hotline-head">
                        <p>Peptoc HOTLINE:</p>
                        <p><a href="tel:707-873-7862"> <span>Call 707-873-7562</span></a></p>
                    </div>
                    <p>
                        <a href="https://www.peptoc.net/hotline">
                        <img className="img200x100" border="0" alt="peptoc" src="https://static.wixstatic.com/media/01c92c_874fa31632064ec7848bb4fcc9c0b3e1~mv2.jpeg/v1/fill/w_594,h_339,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/1E931A16-0575-445A-BF70-0F1972866C14.jpeg" />
                        </a>
                    </p>
                </div>
                <div className="hotline">
                    <div className="hotline-head">
                        <p>NAMI Helpline:</p> 
                        <p><a href="tel:1-800-950-6264"><span>Call 1-800-950-6264</span></a></p>
                    </div>
                    <p>
                        <a href="https://www.nami.org/help">
                        <img className="img200x100" border="0" alt="nami" src="https://namiwc.org/wp-content/uploads/2018/06/nami-logo-blue.jpg" />
                        </a>
                    </p>
                </div>
                <div className="hotline">
                    <div className="hotline-head">
                        <p>The Trevor Project HOTLINE:</p> 
                        <p><a href="tel:212-695-8650"><span>Call 212-695-8650</span></a></p>
                    </div>
                    <p>
                        <a href="https://www.thetrevorproject.org/">
                        <img className="img200x200" border="0" alt="TrevorProject" src="https://cdn.greatnonprofits.org/images/logos/SocialMediaIcon.jpg"/>
                        </a>
                    </p>
                </div>
            </div>
            <div className="container2">
                <div className="hotline">
                    <div className="hotline-head">
                        <p>Anxiety HOTLINE:</p> 
                        <p><a href="tel:866-903-3787"><span>Call 866-903-3787</span></a></p>
                    </div>
                    <p>
                        <a href="https://mentalhealthhotline.org/anxiety-hotline/">
                        <img className="img200x100" border="0" alt="MentalHealth" src="https://cdn-dgljp.nitrocdn.com/ddYdeMwzaIvWCgWJLMyGGDYlFZSElbZR/assets/static/optimized/rev-704434c/wp-content/uploads/2021/08/cropped-Final_logo_colored-300x136ASA-200x91.png" />
                        </a>
                    </p>
                </div>
                <div className="hotline">
                    <div className="hotline-head">
                        <p>Crisis Text Line: Text REASON to </p>
                        <p><a href="tel:741741"><span>741741</span></a></p>
                    </div>
                    <p>
                        <a href="https://www.crisistextline.org/">
                        <img className="img200x50" border="0" alt="CrisisTextLine" src="https://www.datingnews.com/wp-content/uploads/2018/11/ctlogoo.jpg" />
                        </a>
                    </p>
                </div>
            </div>
        </div> 
    )
} 

export default Hotline